<template>
    <div class="row" v-if="offer.offer_props.audit">
        <div class="col-12 m-t-30">
            <h4 class="m-b-0"><i class="fas fa-microscope"></i> Provenance</h4>
            <p class="text-muted m-t-0">Verified provenance of commodities on the blockchain</p>

            <global-gap-report :audit="offer.offer_props.audit" v-if="offer.offer_props.audit && offer.offer_props.audit.type === 'GLOBAL_GAP'"></global-gap-report>
            <r-s-p-o-report :audit="offer.offer_props.audit" v-if="offer.offer_props.audit && offer.offer_props.audit.type === 'RSPO'"></r-s-p-o-report>

        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import GlobalGapReport from "../../../common/audit/GlobalGapReport";
    import RSPOReport from "../../../common/audit/RSPOReport";


    export default {
        name: "TradeProvenance",
        components: {GlobalGapReport,RSPOReport},
        props: {
            tradeid: String,
            trade: Object,
            events: Object
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        watch: {
            trade: function(newVal, oldVal) {
                if(this.trade !== null) {
                    this.init();
                }
            }
        },
        data() {
            return {
                counterparties: [],
                counterparty: {},
                escrowAgencies: [],
                escrow: {},
                offer: {
                    offer_props: {
                        audit: {
                            auditor: {
                                auditor_id: null,
                                email: null,
                                org_id: null,
                                org_name: null
                            },
                            coop_name: null,
                            id: null,
                            status: null,
                            title: null,
                            type: null
                        },
                        commodity_speciality: []
                    }
                }
            }
        },
        mounted() {

        },
        methods: {
            async init(){
                await this.getCounterparties();
                await this.getOffer();
            },
            async getCounterparties() {
                this.$http.get("/counterparties")
                .then((result) => {
                    this.filter(result.data)
                }).catch((err) => {
                    console.log(err)
                });
            },
            filter(result) {
                result.forEach(element => {
                    if(element.type === 'COUNTERPARTY') {
                        this.counterparties.push({id: element.id, label: element.name})
                    }
                    if(element.type === 'ESCROW_AGENT') {
                        this.escrowAgencies.push({id: element.id, label: element.name})
                    }
                });
                this.counterparty = this.counterparties[0];
                this.escrow       = this.escrowAgencies[0];
            },
            async getOffer() {
                let reply  = await this.$http.get(`marketplaces/${this.currentOrg.marketplace_id}/offers/${this.trade.offer_id}`);
                this.offer = reply.data;
            },
        }
    }
</script>

<style scoped>

</style>
